import { Upload } from '@mui/icons-material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { Button } from '@ifs-gcp/components';

import { useAuditStore } from '@/store/auditStore';
import { useRouterStore } from '@/store/routerStore';

type SubmitAuditActionProps = {
  auditCaseUuid: string;
};

export const SubmitAuditAction = observer(({ auditCaseUuid }: SubmitAuditActionProps) => {
  const { t } = useTranslation();
  const audit = useAuditStore((state) => state.audit)!;
  const isActionPending = useAuditStore((state) => state.isActionPending);
  const setSubmitAuditModalCaseUuid = useRouterStore((state) => state.setSubmitAuditModalCaseUuid);

  const handleSubmitAudit = () => {
    setSubmitAuditModalCaseUuid(auditCaseUuid);
  };

  const isSubmitDisabled = Boolean(audit.status.errors.size) || isActionPending;

  return (
    <Button
      variant="contained"
      startIcon={<Upload />}
      onClick={handleSubmitAudit}
      disabled={isSubmitDisabled}
    >
      {t('actions.submit')}
    </Button>
  );
});
